import React from "react";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBInput,
  MDBRow,
  MDBCol,
} from "mdb-react-ui-kit";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import "./UsuariosCCONModal.css";

export class UsuariosCCONModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      usuarios: [],
      nuevaNombre: "",
      nuevaEmail: "",
      editandoId: null,
      editNombre: "",
      editEmail: "",
    };
  }

  componentDidMount() {
    this.cargarUsuarios();
  }

  async cargarUsuarios() {
    this.props.onLoading(true);
    await doFetch("CCON", "getUsuariosCCON", null)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.setState({ usuarios: data.DATA || [] });
        }
      })
      .catch((e) => console.error(e))
      .finally(() => this.props.onLoading(false));
  }

  async crearUsuario() {
    const { nuevaNombre, nuevaEmail } = this.state;
    if (!nuevaNombre.trim()) return;

    this.props.onLoading(true);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nombre: nuevaNombre, email: nuevaEmail }),
    };

    await doFetch("CCON", "insertUsuarioCCON", requestOptions)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.setState({ nuevaNombre: "", nuevaEmail: "" });
          this.cargarUsuarios();
        }
      })
      .catch((e) => console.error(e))
      .finally(() => this.props.onLoading(false));
  }

  iniciarEdicion(usuario) {
    this.setState({
      editandoId: usuario.IDUsuarioCCON,
      editNombre: usuario.nombre,
      editEmail: usuario.email || "",
    });
  }

  cancelarEdicion() {
    this.setState({ editandoId: null, editNombre: "", editEmail: "" });
  }

  async guardarEdicion(IDUsuarioCCON) {
    const { editNombre, editEmail } = this.state;
    if (!editNombre.trim()) return;

    this.props.onLoading(true);
    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        IDUsuarioCCON,
        nombre: editNombre,
        email: editEmail,
      }),
    };

    await doFetch("CCON", "updateUsuarioCCON", requestOptions)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.cancelarEdicion();
          this.cargarUsuarios();
        }
      })
      .catch((e) => console.error(e))
      .finally(() => this.props.onLoading(false));
  }

  async eliminarUsuario(IDUsuarioCCON) {
    this.props.onLoading(true);
    const requestOptions = { method: "DELETE" };
    await doFetch(
      "CCON",
      `deleteUsuarioCCON?IDUsuarioCCON=${IDUsuarioCCON}`,
      requestOptions
    )
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.cargarUsuarios();
        }
      })
      .catch((e) => console.error(e))
      .finally(() => this.props.onLoading(false));
  }

  render() {
    const { show, onClose } = this.props;
    const {
      usuarios,
      nuevaNombre,
      nuevaEmail,
      editandoId,
      editNombre,
      editEmail,
    } = this.state;

    return (
      <MDBModal
        show={show}
        onHide={onClose}
        tabIndex="-1"
      >
        <MDBModalDialog size="lg">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Usuarios colaboradores (externos)</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={onClose}
              />
            </MDBModalHeader>
            <MDBModalBody>
              {/* Formulario nuevo usuario */}
              <div className="usuarios-ccon-new-form mb-3">
                <MDBRow className="align-items-end g-2">
                  <MDBCol size="5">
                    <MDBInput
                      label="Nombre"
                      value={nuevaNombre}
                      onChange={(e) => this.setState({ nuevaNombre: e.target.value })}
                    />
                  </MDBCol>
                  <MDBCol size="5">
                    <MDBInput
                      label="Email (opcional)"
                      type="email"
                      value={nuevaEmail}
                      onChange={(e) => this.setState({ nuevaEmail: e.target.value })}
                    />
                  </MDBCol>
                  <MDBCol size="2">
                    <MDBBtn
                      color="primary"
                      block
                      onClick={() => this.crearUsuario()}
                      disabled={!nuevaNombre.trim()}
                    >
                      <MDBIcon icon="plus" />
                    </MDBBtn>
                  </MDBCol>
                </MDBRow>
              </div>

              {/* Tabla de usuarios existentes */}
              {usuarios.length === 0 ? (
                <p className="text-muted text-center">
                  No hay colaboradores externos. Añade uno arriba.
                </p>
              ) : (
                <MDBTable small hover>
                  <MDBTableHead>
                    <tr>
                      <th>Nombre</th>
                      <th>Email</th>
                      <th style={{ width: 100 }}></th>
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                    {usuarios.map((u) =>
                      editandoId === u.IDUsuarioCCON ? (
                        <tr key={u.IDUsuarioCCON}>
                          <td>
                            <input
                              className="form-control form-control-sm"
                              value={editNombre}
                              onChange={(e) =>
                                this.setState({ editNombre: e.target.value })
                              }
                            />
                          </td>
                          <td>
                            <input
                              className="form-control form-control-sm"
                              type="email"
                              value={editEmail}
                              onChange={(e) =>
                                this.setState({ editEmail: e.target.value })
                              }
                            />
                          </td>
                          <td>
                            <MDBBtn
                              size="sm"
                              color="success"
                              className="me-1"
                              onClick={() => this.guardarEdicion(u.IDUsuarioCCON)}
                            >
                              <MDBIcon icon="check" />
                            </MDBBtn>
                            <MDBBtn
                              size="sm"
                              color="secondary"
                              onClick={() => this.cancelarEdicion()}
                            >
                              <MDBIcon icon="times" />
                            </MDBBtn>
                          </td>
                        </tr>
                      ) : (
                        <tr key={u.IDUsuarioCCON}>
                          <td>{u.nombre}</td>
                          <td className="text-muted">{u.email || "-"}</td>
                          <td>
                            <MDBBtn
                              size="sm"
                              color="light"
                              className="me-1"
                              onClick={() => this.iniciarEdicion(u)}
                            >
                              <MDBIcon icon="edit" />
                            </MDBBtn>
                            <MDBBtn
                              size="sm"
                              color="danger"
                              onClick={() => this.eliminarUsuario(u.IDUsuarioCCON)}
                            >
                              <MDBIcon icon="trash" />
                            </MDBBtn>
                          </td>
                        </tr>
                      )
                    )}
                  </MDBTableBody>
                </MDBTable>
              )}
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    );
  }
}
